<div style="background-color: white;">
    <!-- <nz-tabs nzSize="small" (nzSelectedIndexChange)="selectedFile.set(logFiles[$event])">
        @for(file of logFiles; track file){
            <nz-tab [nzTitle]="file"></nz-tab>
        }
    </nz-tabs> -->

    <div class="log-header">
        <div class="log-header-left">
            <span nz-icon nzType="file-text" nzTheme="outline" class="log-icon"></span>
            <nz-select [(ngModel)]="selectedFile" nzVariant="underlined" class="log-title">
                @for(file of logFiles; track file){<nz-option [nzLabel]="file" [nzValue]="file"></nz-option>}
            </nz-select>

            <nz-divider nzType="vertical"></nz-divider>
            
            @if (isLoading){
                <nz-tag>
                    <nz-icon nzType="loading" nzTheme="outline"></nz-icon>
                    Loading
                </nz-tag>
            }@else{
                <nz-tag [nzColor]="errorsTotal() ? 'error' : 'default'">
                    <nz-icon nzType="close-circle" nzTheme="outline"></nz-icon>
                    {{ errorsTotal() }} Error{{ errorsTotal() !== 1 ? 's' : '' }}
                </nz-tag>
                <nz-tag [nzColor]="warningsTotal() ? 'warning' : 'default'">
                    <nz-icon nzType="warning" nzTheme="outline"></nz-icon>
                    {{ warningsTotal() }} Warning{{ warningsTotal() !== 1 ? 's' : '' }}
                </nz-tag>
            }
            <button nz-button nzType="default" nzSize="small" (click)="download()" nz-tooltip 
                nzTooltipTitle="Download full log" [nzLoading]="isDownloading">
                <span nz-icon nzType="download" nzTheme="outline"></span>
                Download
            </button>
        </div>
    </div>

    <nz-spin [nzSpinning]="isLoading">
        @if (selectedFile()){
        <nz-tabs nzType="line" nzSize="small" class="log-tabs">

            <!-- ───────────── ERRORS TAB ───────────── -->
            <nz-tab [nzTitle]="errorsTitle">
                <ng-template #errorsTitle>
                    <div style="display: flex; align-items: center;">
                        <span nz-icon nzType="close-circle" nzTheme="outline" style="color: #f5222d"></span>
                        Errors
                    </div>
                </ng-template>
                <ng-template nz-tab>

                    <!-- SUMMARY VIEW -->
                    @if (errorsView === 'summary') {

                    @if (fileErrorsSummary.isLoading()) {
                    <div class="log-viewer-loading">
                        <nz-spin [nzSpinning]="true" nzTip="Loading summary..."></nz-spin>
                    </div>
                    } @else if(!fileErrorsSummary.error()) {
                    <div class="summary-toolbar">
                        <span class="summary-toolbar__label">
                            <span nz-icon nzType="unordered-list" nzTheme="outline"></span>
                            {{ (fileErrorsSummary.value() ?? []).length }} classification{{ (fileErrorsSummary.value()
                            ??
                            []).length !== 1 ? 's' : '' }}
                            &nbsp;·&nbsp;
                            {{ errorsTotal() }} total
                        </span>
                        <button nz-button nzType="link" nzSize="small" (click)="errorsView = 'list'">
                            View all <span nz-icon nzType="right"></span>
                        </button>
                    </div>

                    @let errors = fileErrorsSummary.value() ?? [];
                    @if (!errors.length) {
                    <nz-empty nzNotFoundContent="No errors found"></nz-empty>
                    } @else {
                    <div class="summary-list">
                        <nz-collapse [nzBordered]="false">
                            @for (item of errors; track item.classification) {
                            <nz-collapse-panel [nzHeader]="errorSummaryHeader" [nzExtra]="errorSummaryExtra">
                                <ng-template #errorSummaryHeader>
                                    <span class="summary-classification summary-classification--error">{{
                                        item.classification }}</span>
                                </ng-template>
                                <ng-template #errorSummaryExtra>
                                    <nz-tag nzColor="error" class="summary-count-tag">
                                        × {{ item.count }}
                                    </nz-tag>
                                </ng-template>
                                <div class="summary-lines">
                                    @for (line of item.lines; track $index) {
                                    <div class="summary-line summary-line--error">
                                        <span nz-icon nzType="close-circle" nzTheme="fill"
                                            class="badge-error summary-line__icon"></span>
                                        <span class="summary-line__text">{{ line }}</span>
                                    </div>
                                    }
                                </div>
                            </nz-collapse-panel>
                            }
                        </nz-collapse>
                    </div>
                    <div class="summary-footer">
                        <button nz-button nzType="default" nzSize="small" (click)="errorsView = 'list'">
                            <span nz-icon nzType="unordered-list" nzTheme="outline"></span>
                            Browse all {{ errorsTotal() }} errors
                            <span nz-icon nzType="right"></span>
                        </button>
                    </div>
                    }
                    }
                    }

                    <!-- FULL LIST VIEW -->
                    @if (errorsView === 'list') {
                    @if(errorsPaginator?.results$ | async; as errors) {
                    <ng-container>
                        <div class="pagination-row">
                            <button nz-button nzType="link" nzSize="small" (click)="errorsView = 'summary'"
                                class="back-btn">
                                <span nz-icon nzType="left"></span> Summary
                            </button>
                            <span class="pagination-info">{{ errorsPaginator.count }} total</span>
                            <div class="pagination-controls">
                                <button nz-button nzSize="small"
                                    [disabled]="!errorsPaginator.hasPrevious || (errorsPaginator.loading$ | async)"
                                    (click)="errorsPaginator.loadPrevious()">
                                    <span nz-icon nzType="left"></span> Prev
                                </button>
                                <button nz-button nzSize="small"
                                    [disabled]="!errorsPaginator.hasNext || (errorsPaginator.loading$ | async)"
                                    (click)="errorsPaginator.loadNext()">
                                    Next <span nz-icon nzType="right"></span>
                                </button>
                            </div>
                        </div>
                        <div class="log-viewer">
                            @if (errorsPaginator.loading$ | async) {
                            <div class="log-viewer-loading">
                                <nz-spin [nzSpinning]="true" nzTip="Loading..."></nz-spin>
                            </div>
                            } @else if (!errors.length) {
                            <nz-empty nzNotFoundContent="No errors found"></nz-empty>
                            } @else {
                            @for (line of errors; track line.line) {
                            <div class="log-line log-line--error">
                                <span class="log-line__number">{{ line.line }}</span>
                                <span class="log-line__badge">
                                    <span nz-icon nzType="close-circle" nzTheme="fill" class="badge-error"></span>
                                </span>
                                <span class="log-line__content">{{ line.text }}</span>
                            </div>
                            }
                            }
                        </div>
                    </ng-container>
                    }
                    }
                </ng-template>
            </nz-tab>

            <!-- ───────────── WARNINGS TAB ───────────── -->
            <nz-tab [nzTitle]="warningsTitle">
                <ng-template #warningsTitle>
                    <div style="display: flex; align-items: center;">
                        <span nz-icon nzType="warning" nzTheme="outline" style="color: #faad14"></span>
                        Warnings
                    </div>
                </ng-template>
                <ng-template nz-tab>

                    <!-- SUMMARY VIEW -->
                    @if (warningsView === 'summary') {

                    @if (fileWarningsSummary.isLoading()) {
                    <div class="log-viewer-loading">
                        <nz-spin [nzSpinning]="true" nzTip="Loading summary..."></nz-spin>
                    </div>
                    } @else if(!fileWarningsSummary.error()) {
                    <div class="summary-toolbar">
                        <span class="summary-toolbar__label">
                            <span nz-icon nzType="unordered-list" nzTheme="outline"></span>
                            {{ (fileWarningsSummary.value() ?? []).length }} classification{{
                            (fileWarningsSummary.value()
                            ?? []).length !== 1 ? 's' : '' }}
                            &nbsp;·&nbsp;
                            {{ warningsTotal() }} total
                        </span>
                        <button nz-button nzType="link" nzSize="small" (click)="warningsView = 'list'">
                            View all <span nz-icon nzType="right"></span>
                        </button>
                    </div>

                    @let warnings = fileWarningsSummary.value() ?? [];
                    @if (!warnings.length) {
                    <nz-empty nzNotFoundContent="No warnings found"></nz-empty>
                    } @else {
                    <div class="summary-list">
                        <nz-collapse [nzBordered]="false">
                            @for (item of warnings; track item.classification) {
                            <nz-collapse-panel [nzHeader]="warningSummaryHeader" [nzExtra]="warningSummaryExtra">
                                <ng-template #warningSummaryHeader>
                                    <span class="summary-classification summary-classification--warning">{{
                                        item.classification
                                        }}</span>
                                </ng-template>
                                <ng-template #warningSummaryExtra>
                                    <nz-tag nzColor="warning" class="summary-count-tag">
                                        × {{ item.count }}
                                    </nz-tag>
                                </ng-template>
                                <div class="summary-lines">
                                    @for (line of item.lines; track $index) {
                                    <div class="summary-line summary-line--warning">
                                        <span nz-icon nzType="warning" nzTheme="fill"
                                            class="badge-warning summary-line__icon"></span>
                                        <span class="summary-line__text">{{ line }}</span>
                                    </div>
                                    }
                                </div>
                            </nz-collapse-panel>
                            }
                        </nz-collapse>
                    </div>
                    <div class="summary-footer">
                        <button nz-button nzType="default" nzSize="small" (click)="warningsView = 'list'">
                            <span nz-icon nzType="unordered-list" nzTheme="outline"></span>
                            Browse all {{ warningsTotal() }} warnings
                            <span nz-icon nzType="right"></span>
                        </button>
                    </div>
                    }
                    }
                    }

                    <!-- FULL LIST VIEW -->
                    @if (warningsView === 'list') {
                    @if(warningsPaginator?.results$ | async; as warnings) {
                    <ng-container>
                        <div class="pagination-row">
                            <button nz-button nzType="link" nzSize="small" (click)="warningsView = 'summary'"
                                class="back-btn">
                                <span nz-icon nzType="left"></span> Summary
                            </button>
                            <span class="pagination-info">{{ warningsPaginator.count }} total</span>
                            <div class="pagination-controls">
                                <button nz-button nzSize="small"
                                    [disabled]="!warningsPaginator.hasPrevious || (warningsPaginator.loading$ | async)"
                                    (click)="warningsPaginator.loadPrevious()">
                                    <span nz-icon nzType="left"></span> Prev
                                </button>
                                <button nz-button nzSize="small"
                                    [disabled]="!warningsPaginator.hasNext || (warningsPaginator.loading$ | async)"
                                    (click)="warningsPaginator.loadNext()">
                                    Next <span nz-icon nzType="right"></span>
                                </button>
                            </div>
                        </div>
                        <div class="log-viewer">
                            @if (warningsPaginator.loading$ | async) {
                            <div class="log-viewer-loading">
                                <nz-spin [nzSpinning]="true" nzTip="Loading..."></nz-spin>
                            </div>
                            } @else if (!warnings.length) {
                            <nz-empty nzNotFoundContent="No warnings found"></nz-empty>
                            } @else {
                            @for (line of warnings; track line.line) {
                            <div class="log-line log-line--warning">
                                <span class="log-line__number">{{ line.line }}</span>
                                <span class="log-line__badge">
                                    <span nz-icon nzType="warning" nzTheme="fill" class="badge-warning"></span>
                                </span>
                                <span class="log-line__content">{{ line.text }}</span>
                            </div>
                            }
                            }
                        </div>
                    </ng-container>
                    }
                    }
                </ng-template>
            </nz-tab>
        </nz-tabs>
        }
    </nz-spin>
</div>